module.exports = __webpack_public_path__ + "static/media/ic_rekka_b.f06a4afb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_rekka_b.svg
// module id = 1163
// module chunks = 0